import { Stack, Typography } from '@mui/material'
import { useMode, useStorageSaturationPercent } from '../../ContextProvider'
import { useTexts } from './useTexts'

export function Body() {
  const mode = useMode()
  const texts = useTexts()
  const storageSaturationPercent = useStorageSaturationPercent()

  return (
    <Stack>
      <Typography>{texts.body.description(storageSaturationPercent, mode)}</Typography>
    </Stack>
  )
}
